/**
 * Strings the three screens share. Everything a single screen owns lives in
 * that screen's own `copy.ts`.
 *
 * The copy addresses the operator, never the reviewer: no design rationale, no
 * technical vocabulary, no restatement of a mechanic the screen performs in
 * front of them. The test before shipping a line is whether the operator can
 * act differently after reading it.
 */
export const authCopy = {
  /** The line above every form, because a red asterisk cannot carry the rule alone. */
  requiredNote: 'الحقول المعلَّمة بـ',
  requiredNoteTail: ' مطلوبة.',

  shell: {
    /** The lockup is a `<span>` here: the console root cannot be opened yet. */
    brandLabel: 'شاهدني',
  },

  /**
   * The one refusal that is not an error. It renders on the sign-in screen when
   * the guard turned a real session away — the account authenticated correctly
   * and holds no operator role, and there is no route by which it can ask for
   * one. Saying so costs a sentence; not saying it produces a screen that looks
   * broken to the person it is refusing.
   */
  roleNotice: {
    title: 'حسابك لا يحمل دور مشغّل',
    body: 'الدخول صحيح، لكنّ وحدة التحكّم تحتاج دور مشغّل يمنحه مشغّل آخر من صفحة المستخدم.',
  },

  /** Field-level failures the browser's own constraint would otherwise phrase in English. */
  field: {
    phoneRequired: 'أدخل رقم موبايلك.',
    phoneInvalid: 'أدخل رقم موبايل يمنيّاً كاملاً، مثل ٧٧١\u00a0٢٣٤\u00a0٥٦٧ أو ‎+٩٦٧٧٧١٢٣٤٥٦٧.',
    codeRequired: 'أدخل الرمز الذي وصلك في الرسالة النصّية.',
    codeTooLong: 'الرمز أطول ممّا يُرسَل في الرسالة.',
    passwordRequired: 'أدخل كلمة المرور.',
    passwordTooShort: 'كلمة المرور ثمانية محارف على الأقلّ.',
    passwordTooLong: 'كلمة المرور أطول ممّا يقبله الحساب.',
    passwordMismatch: 'الكلمتان غير متطابقتين.',
  },

  /** What the banner says was unaffected — the auth screens hold no catalogue. */
  unaffected: 'لم يتغيّر شيء في حسابك.',
} as const;
